module.exports = __webpack_public_path__ + "img/Sintomas Cancro Europeu na Colheita 6.7eb40a71.webp";